module.exports = __webpack_public_path__ + "static/media/movies1.10f3e0a7.png";